import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import * as XLSX from 'xlsx'
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { ticketsAPI, projetsAPI, usersAPI } from "../../services/api"
import { Link } from "react-router-dom"
import AlertModal from "../../components/Common/AlertModal"

const TicketList = (props) => {
    const { myTickets } = props;
    document.title = (myTickets ? "Mes Tickets" : "Liste des Tickets") + " | Ticket Management"

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isCollaborateur = user.role === 'collaborateur';

    const [tickets, setTickets] = useState([])
    const [projets, setProjets] = useState([])
    const [users, setUsers] = useState([])
    const [etapes, setEtapes] = useState([])
    const [modal, setModal] = useState(false)
    const [editingTicket, setEditingTicket] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [selectedProject, setSelectedProject] = useState("")

    const [formData, setFormData] = useState({
        titre: "",
        description: "",
        projet_id: "",
        etape_id: "",
        assigned_to: "",
        priorite: "normale",
        heures_estimees: "",
        reward_points: "0",
        deadline: "",
    })

    const [alertConfig, setAlertConfig] = useState({
        isOpen: false,
        type: 'success',
        message: '',
        title: ''
    })

    const toggleAlert = () => setAlertConfig({ ...alertConfig, isOpen: !alertConfig.isOpen })

    const [importModal, setImportModal] = useState(false)
    const [importData, setImportData] = useState([])
    const [importProject, setImportProject] = useState("")
    const [importLoading, setImportLoading] = useState(false)

    const toggleImportModal = () => {
        setImportModal(!importModal)
        if (!importModal) {
            setImportData([])
            setImportProject("")
        }
    }

    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: myTickets ? "Mes Tickets" : "Tickets", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems(myTickets ? "Mes Tickets" : "Liste des Tickets", breadcrumbItems)
        fetchData()
    }, [myTickets])

    const fetchData = async () => {
        try {
            console.log("🔍 FETCH DATA - User:", user);
            console.log("🔍 FETCH DATA - Role:", user.role);
            console.log("🔍 FETCH DATA - MyTickets Prop:", myTickets);

            const params = {
                per_page: 500,
                ...(myTickets ? { assigned_to: user.id } : {})
            };
            const [ticketRes, projRes, userRes] = await Promise.all([
                ticketsAPI.getAll(params),
                projetsAPI.getAll(),
                usersAPI.getAll()
            ])
            // L'API tickets renvoie une pagination, donc ticketRes.data.data
            let ticketsList = ticketRes.data?.data || ticketRes.data || [];
            console.log("🔍 FETCH DATA - Tickets from API (total):", ticketsList.length);

            // Sécurité supplémentaire côté front pour les collaborateurs
            if (user.role === 'collaborateur') {
                console.log("🔍 APPLYING FRONTEND FILTER for collaborateur");
                ticketsList = ticketsList.filter(t => {
                    const assignedId = String(t.assigned_to?.id || t.assigned_to || "");
                    const createdById = String(t.created_by?.id || t.created_by || "");
                    const currentUserId = String(user.id);
                    const isMatch = assignedId === currentUserId || createdById === currentUserId;
                    if (!isMatch) {
                        console.log(`   🚫 Filtering out ticket #${t.id} - Assigned: ${assignedId}, CreatedBy: ${createdById}, CurrentUser: ${currentUserId}`);
                    }
                    return isMatch;
                });
                console.log("🔍 FETCH DATA - Tickets after filter:", ticketsList.length);
            }

            setTickets(Array.isArray(ticketsList) ? ticketsList : []);
            setProjets(projRes.data)
            setUsers(userRes.data)
        } catch (error) {
            console.error("Erreur lors du chargement des données", error)
        }
    }

    const fetchEtapes = async (projetId) => {
        if (!projetId) {
            setEtapes([]);
            return;
        }
        try {
            const res = await projetsAPI.getEtapes(projetId);
            const etapesList = Array.isArray(res.data) ? res.data : [];
            setEtapes(etapesList.sort((a, b) => a.ordre - b.ordre));
        } catch (error) {
            console.error('Erreur chargement étapes', error);
            setEtapes([]);
        }
    }

    const toggleModal = () => {
        setModal(!modal)
        if (!modal) {
            setEditingTicket(null)
            setEtapes([])
            setFormData({
                titre: "",
                description: "",
                projet_id: "",
                etape_id: "",
                assigned_to: "",
                priorite: "normale",
                heures_estimees: "",
                reward_points: "0",
                deadline: "",
            })
        }
    }

    const handleEdit = (ticket) => {
        setEditingTicket(ticket)
        // Charger les étapes du projet
        if (ticket.projet_id) {
            fetchEtapes(ticket.projet_id)
        }
        setFormData({
            titre: ticket.titre,
            description: ticket.description,
            projet_id: ticket.projet_id,
            etape_id: ticket.etape_id || "",
            assigned_to: ticket.assigned_to?.id || ticket.assigned_to || "",
            priorite: ticket.priorite,
            heures_estimees: ticket.heures_estimees || "",
            reward_points: ticket.reward_points || "0",
            deadline: ticket.deadline ? ticket.deadline.substring(0, 10) : "",
        })
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce ticket ?")) {
            try {
                await ticketsAPI.delete(id)
                fetchData()
            } catch (error) {
                console.error("Erreur lors de la suppression", error)
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (isSubmitting) return
        setIsSubmitting(true)
        try {
            if (editingTicket) {
                await ticketsAPI.update(editingTicket.id, formData)
                setAlertConfig({
                    isOpen: true,
                    type: 'success',
                    title: 'Mis à jour',
                    message: 'Le ticket a été mis à jour avec succès.'
                })
            } else {
                await ticketsAPI.create(formData)
                setAlertConfig({
                    isOpen: true,
                    type: 'success',
                    title: 'Créé',
                    message: 'Le ticket a été créé avec succès.'
                })
            }
            toggleModal()
            fetchData()
        } catch (error) {
            console.error("Erreur lors de l'enregistrement", error)
            setAlertConfig({
                isOpen: true,
                type: 'error',
                title: 'Erreur',
                message: "Une erreur est survenue lors de l'enregistrement du ticket."
            })
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0]
        const reader = new FileReader()
        reader.onload = (event) => {
            const bstr = event.target.result
            const wb = XLSX.read(bstr, { type: 'binary', cellDates: true })
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]
            const data = XLSX.utils.sheet_to_json(ws)

            // Mapper les données Excel vers le format attendu par le backend
            const mappedData = data.map(row => {
                let deadline = row['Échéance'] || row['Deadline'] || row['echeance'] || null;

                // 1. Si c'est un objet Date de JS (merci cellDates: true)
                if (deadline instanceof Date) {
                    deadline = deadline.toISOString().split('T')[0];
                }
                // 2. Si c'est une chaîne de caractères (ex: "10-03-2026" ou "10/03/2026")
                else if (typeof deadline === 'string' && deadline.trim() !== '') {
                    const parts = deadline.split(/[-/]/); // Découper par - ou /
                    if (parts.length === 3) {
                        // On assume le format JJ, MM, AAAA
                        const day = parts[0].trim().padStart(2, '0');
                        const month = parts[1].trim().padStart(2, '0');
                        const year = parts[2].trim();

                        // Si l'année est à la fin (DD-MM-YYYY)
                        if (year.length === 4) {
                            deadline = `${year}-${month}-${day}`;
                        }
                        // Si l'année est au début (YYYY-MM-DD)
                        else if (parts[0].trim().length === 4) {
                            deadline = `${parts[0].trim()}-${parts[1].trim().padStart(2, '0')}-${parts[2].trim().padStart(2, '0')}`;
                        }
                    }
                }

                return {
                    titre: row['Ticket Title'] || row['Titre'] || row['titre'] || row['Nom du Module'] || row['module'] || '',
                    description: row['Description'] || row['description'] || '',
                    priorite: row['Priority'] || row['Priorité'] || row['priorite'] || 'normale',
                    deadline: deadline,
                    heures_estimees: row['Heures estimées'] || row['Estimated Hours'] || row['heures_estimees'] || null,
                    reward_points: row['Points de récompense'] || row['Reward Points'] || row['reward_points'] || 0
                }
            }).filter(item => item.titre)

            setImportData(mappedData)
        }
        reader.readAsBinaryString(file)
    }

    const handleImport = async () => {
        if (!importProject) {
            alert("Veuillez sélectionner un projet pour l'import.")
            return
        }
        if (importData.length === 0) {
            alert("Aucune donnée valide trouvée dans le fichier Excel.")
            return
        }

        setImportLoading(true)
        try {
            await ticketsAPI.import({
                projet_id: importProject,
                tickets: importData
            })
            setAlertConfig({
                isOpen: true,
                type: 'success',
                title: 'Import Réussi',
                message: `${importData.length} tickets ont été importés avec succès.`
            })
            toggleImportModal()
            fetchData()
        } catch (error) {
            console.error("Erreur import", error)
            setAlertConfig({
                isOpen: true,
                type: 'error',
                title: 'Erreur Import',
                message: "Une erreur est survenue lors de l'import des tickets."
            })
        } finally {
            setImportLoading(false)
        }
    }

    const getPriorityBadge = (prio) => {
        const colors = { basse: 'info', normale: 'secondary', haute: 'primary', urgente: 'danger' }
        return <span className={`badge bg-${colors[prio] || 'secondary'}`}>{prio.toUpperCase()}</span>
    }

    const getStatusBadge = (statut) => {
        const colors = { en_cours: 'warning', en_attente: 'info', reopen: 'warning', resolu: 'success', ferme: 'secondary' }
        return <span className={`badge bg-${colors[statut] || 'secondary'}`}>{statut.toUpperCase().replace('_', ' ')}</span>
    }

    const data = {
        columns: [
            { label: "Titre", field: "titre", sort: "asc" },
            { label: "Projet", field: "projet", sort: "asc" },
            { label: "Assigné à", field: "assigned", sort: "asc" },
            { label: "Priorité", field: "prioriteDisplay", sort: "asc" },
            { label: "Statut", field: "statutDisplay", sort: "asc" },
            { label: "Échéance", field: "deadline", sort: "asc" },
            { label: "Actions", field: "actions", sort: "disabled" },
        ],
        rows: (Array.isArray(tickets) ? tickets : [])
            .filter(t => !selectedProject || String(t.projet?.id || t.projet_id) === String(selectedProject))
            .map((t) => ({
                titre: <Link to={`/tickets/${t.id}`}>{t.titre}</Link>,
                projet: t.projet ? t.projet.nom : '-',
                assigned: t.assigned_to ? (t.assigned_to.name || users.find(u => u.id === t.assigned_to)?.name || '-') : '-',
                prioriteDisplay: getPriorityBadge(t.priorite),
                statutDisplay: getStatusBadge(t.statut),
                deadline: t.deadline ? new Date(t.deadline).toLocaleDateString() : "-",
                actions: (
                    <div className="d-flex gap-2">
                        <Button color="primary" size="sm" onClick={() => handleEdit(t)}>
                            <i className="mdi mdi-pencil"></i>
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleDelete(t.id)}>
                            <i className="mdi mdi-trash-can"></i>
                        </Button>
                    </div>
                ),
            })),
    }

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <CardTitle className="h4">{myTickets ? "Mes Tickets" : "Liste des Tickets"}</CardTitle>
                                <div className="d-flex gap-3 align-items-center">
                                    <div style={{ minWidth: "200px" }}>
                                        <Input
                                            type="select"
                                            className="form-select-sm"
                                            value={selectedProject}
                                            onChange={(e) => setSelectedProject(e.target.value)}
                                        >
                                            <option value="">Tous les projets</option>
                                            {projets.map((p) => (
                                                <option key={p.id} value={p.id}>{p.nom}</option>
                                            ))}
                                        </Input>
                                    </div>
                                    {!isCollaborateur && (
                                        <div className="d-flex gap-2">
                                            <Button color="info" onClick={toggleImportModal}>
                                                <i className="mdi mdi-file-excel me-1"></i> Importer Excel
                                            </Button>
                                            <Button color="success" onClick={toggleModal}>
                                                <i className="mdi mdi-plus me-1"></i> Nouveau Ticket
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <MDBDataTable
                                noBottomColumns
                                responsive
                                striped
                                bordered
                                data={data}
                                entriesLabel="Afficher"
                                searchLabel="Rechercher"
                                infoLabel={["Affichage de", "à", "sur", "entrées"]}
                                paginationLabel={["Précédent", "Suivant"]}
                                noRecordsFoundLabel="Aucun enregistrement trouvé"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>
                    {editingTicket ? "Modifier le Ticket" : "Nouveau Ticket"}
                </ModalHeader>
                <Form onSubmit={handleSubmit}>
                    <ModalBody>
                        <FormGroup>
                            <Label for="titre">Titre du Ticket</Label>
                            <Input
                                type="text"
                                id="titre"
                                value={formData.titre}
                                onChange={(e) => setFormData({ ...formData, titre: e.target.value })}
                                required
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="description">Description</Label>
                            <Input
                                type="textarea"
                                id="description"
                                rows="4"
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                required
                            />
                        </FormGroup>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="projet_id">Projet</Label>
                                    <Input
                                        type="select"
                                        id="projet_id"
                                        value={formData.projet_id}
                                        onChange={(e) => {
                                            const projetId = e.target.value;
                                            setFormData({ ...formData, projet_id: projetId, etape_id: "" });
                                            fetchEtapes(projetId);
                                        }}
                                        required
                                    >
                                        <option value="">Sélectionner un projet</option>
                                        {projets.map((p) => (
                                            <option key={p.id} value={p.id}>{p.nom}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="etape_id">Étape *</Label>
                                    <Input
                                        type="select"
                                        id="etape_id"
                                        value={formData.etape_id}
                                        onChange={(e) => setFormData({ ...formData, etape_id: e.target.value })}
                                        disabled={!formData.projet_id}
                                        required
                                    >
                                        <option value="">Sélectionner une étape</option>
                                        {etapes.map((e) => (
                                            <option key={e.id} value={e.id}>
                                                {e.ordre}. {e.nom}
                                            </option>
                                        ))}
                                    </Input>
                                    {!formData.projet_id && (
                                        <small className="text-muted">Sélectionnez d'abord un projet</small>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="assigned_to">Assigner à</Label>
                                    <Input
                                        type="select"
                                        id="assigned_to"
                                        value={formData.assigned_to}
                                        onChange={(e) => setFormData({ ...formData, assigned_to: e.target.value })}
                                    >
                                        <option value="">Non assigné</option>
                                        {users.filter(u => u.role !== 'client').map((u) => (
                                            <option key={u.id} value={u.id}>{u.name} ({u.role})</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="priorite">Priorité</Label>
                                    <Input
                                        type="select"
                                        id="priorite"
                                        value={formData.priorite}
                                        onChange={(e) => setFormData({ ...formData, priorite: e.target.value })}
                                    >
                                        <option value="basse">Basse</option>
                                        <option value="normale">Normale</option>
                                        <option value="haute">Haute</option>
                                        <option value="urgente">Urgente</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="heures_estimees">Heures estimées</Label>
                                    <Input
                                        type="number"
                                        id="heures_estimees"
                                        step="0.5"
                                        value={formData.heures_estimees}
                                        onChange={(e) => setFormData({ ...formData, heures_estimees: e.target.value })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="deadline">Échéance</Label>
                                    <Input
                                        type="date"
                                        id="deadline"
                                        value={formData.deadline}
                                        onChange={(e) => setFormData({ ...formData, deadline: e.target.value })}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="reward_points">Points de récompense</Label>
                                    <Input
                                        type="number"
                                        id="reward_points"
                                        value={formData.reward_points}
                                        onChange={(e) => setFormData({ ...formData, reward_points: e.target.value })}
                                        placeholder="0"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal} disabled={isSubmitting}>Annuler</Button>
                        <Button color="primary" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? (
                                <>
                                    <i className="mdi mdi-loading mdi-spin me-1"></i> Enregistrement...
                                </>
                            ) : "Enregistrer"}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>

            <AlertModal
                isOpen={alertConfig.isOpen}
                toggle={toggleAlert}
                type={alertConfig.type}
                title={alertConfig.title}
                message={alertConfig.message}
            />

            <Modal isOpen={importModal} toggle={toggleImportModal} size="md">
                <ModalHeader toggle={toggleImportModal}>Importer des Tickets depuis Excel</ModalHeader>
                <ModalBody>
                    <p className="text-muted mb-4">
                        Le fichier Excel peut contenir les colonnes suivantes :
                        <strong> Nom du Module (Titre), Description, Priority, Échéance, Heures estimées, Points de récompense</strong>.
                    </p>
                    <FormGroup>
                        <Label>Projet de destination</Label>
                        <Input
                            type="select"
                            value={importProject}
                            onChange={(e) => setImportProject(e.target.value)}
                            required
                        >
                            <option value="">Sélectionner un projet</option>
                            {projets.map((p) => (
                                <option key={p.id} value={p.id}>{p.nom}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label>Fichier Excel</Label>
                        <Input
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                        />
                    </FormGroup>
                    {importData.length > 0 && (
                        <div className="mt-3">
                            <p className="text-success">
                                <i className="mdi mdi-check-circle me-1"></i>
                                {importData.length} tickets prêts à être importés.
                            </p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleImportModal} disabled={importLoading}>Annuler</Button>
                    <Button
                        color="info"
                        onClick={handleImport}
                        disabled={importLoading || importData.length === 0 || !importProject}
                    >
                        {importLoading ? "Importation..." : "Lancer l'import"}
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(TicketList)
